//==============================================================================
// Variable Replacer
//
// General purpose tool to replace variables within a string
//==============================================================================

export function varReplace(text: string, vars: {[key: string]: string}): string {
    return text.replace(/{(.+?)}/g, (_, match) => vars[match] || '');
}
